import { z } from 'zod';

/**
 * A user's personal referral link. Generated on first request and stable
 * thereafter — one code per user.
 */
export const ReferralCodeSchema = z.object({
  code: z.string(),
  url: z.string(),
});
export type ReferralCode = z.infer<typeof ReferralCodeSchema>;
